import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useMemo } from 'react';
import DIcon from '../DIcon';
import { useDContext } from '../../contexts';
export default function DStepper({ options, currentStep, iconSuccess: iconSuccessProp, iconSuccessFamilyClass, iconSuccessFamilyPrefix, iconSuccessMaterialStyle = false, vertical = false, completed, alignStart = false, className, style, }) {
    const { iconMap: { check, }, } = useDContext();
    const icon = useMemo(() => iconSuccessProp || check, [check, iconSuccessProp]);
    if (currentStep < 1 || currentStep > options.length) {
        throw new Error('Current step should be in the range from 1 to options length');
    }
    return (_jsx("div", { className: classNames({
            'd-stepper-desktop': true,
            'is-vertical': vertical,
            'is-align-start': alignStart && !vertical,
        }, className), style: style, children: options.map(({ label, value, description }) => (_jsxs("div", { className: classNames({
                'd-step': true,
                'd-step-current': value === currentStep && !completed,
            }), children: [_jsx("div", { className: "d-step-value", children: _jsxs("div", { className: classNames({
                            'd-step-icon-container': true,
                            'd-step-check': value < currentStep || completed,
                        }), children: [((value < currentStep) || completed) && (_jsx(DIcon, { icon: icon, familyClass: iconSuccessFamilyClass, familyPrefix: iconSuccessFamilyPrefix, materialStyle: iconSuccessMaterialStyle, className: "d-step-icon" })), value] }) }), _jsxs("div", { className: "d-step-text-container", children: [_jsx("div", { className: "d-step-label", children: label }), description && (_jsx("div", { className: "d-step-description", children: description }))] })] }, value))) }));
}
//# sourceMappingURL=DStepperDesktop.js.map